import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getBasicHeaders, getHeadersWithFormData } from '@/common/utils/utils';
import { wrapAction } from '@/common/utils/actionLifecycle';
import {
    generateDefaultBreadcrumbsForManageChapterStudio,
    generateManageChapterStudioBreadcrumbForCreateFlow,
    getDefaultPicklist,
} from "@/components/ChapterStudioPageManage/manageChapterStudio.constant";
import { routerNames } from "@/components/appCommon.constants";

const manageChapterStudioState = {
    baseURL: process.env.VUE_APP_BASE_URL,
    announcements: [],
    pastAnnouncements: [],
    breadcrumbList: [],
    pickLists: getDefaultPicklist(),
};

const manageChapterStudioMutations = {
    [storeMutation.setAnnouncementsForManageChapterStudio]: (state, announcementData) => {
        if (announcementData && announcementData.length) {
            state.announcements = announcementData;
        }
    },
    [storeMutation.setPastAnnouncementsForManageChapterStudio]: (state, announcementData) => {
        if (announcementData && announcementData.length) {
            state.pastAnnouncements = announcementData;
        }
    },
    [storeMutation.setChapterStudioPicklists]: (state, picklistData) => {
        let data = getDefaultPicklist();
        if (picklistData) data = { ...data, ...picklistData };
        state.pickLists = data;
    },
    [storeMutation.setBreadcrumbList]: (state, data) => {
        const { toRoute, fromRoute } = data;
        if (toRoute && fromRoute) {
            if (toRoute.name === routerNames.MANAGE_CHAPTER_STUDIO) {
                if (fromRoute.name === routerNames.CREATE_ANNOUNCEMENT) {
                    state.breadcrumbList = generateManageChapterStudioBreadcrumbForCreateFlow(state.breadcrumbList);
                } else {
                    state.breadcrumbList = generateDefaultBreadcrumbsForManageChapterStudio(fromRoute);
                }
            } else if (toRoute.name === routerNames.CREATE_ANNOUNCEMENT) {
                if (fromRoute.name !== routerNames.MANAGE_CHAPTER_STUDIO) {
                    state.breadcrumbList =
                        generateManageChapterStudioBreadcrumbForCreateFlow(generateDefaultBreadcrumbsForManageChapterStudio(fromRoute));
                } else {
                    state.breadcrumbList = generateManageChapterStudioBreadcrumbForCreateFlow(state.breadcrumbList);
                }
            }
        }
    },
};

const manageChapterStudioActions = {
    [storeAction.getAllChapterStudioAnnouncements]: wrapAction(
        storeAction.getAllChapterStudioAnnouncements,
        ({ state, commit }) => {
            //handling race condition
            return axios({
                 url: `${state.baseURL}communities/api/communities/getAllAnnouncements`,
                // url: `/mocks/chapterStudioAnnouncementsForManage.json`, //TODO - update the data structure in this mock
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    if (response && response.data) {
                        commit(storeMutation.setAnnouncementsForManageChapterStudio, response.data);
                    }
                    return response;
                })
                .catch((err) => {
                    throw err;
                });
        },
    ),
    [storeAction.getPastChapterStudioAnnouncements]: wrapAction(
        storeAction.getPastChapterStudioAnnouncements,
        ({ state, commit }) => {
            //handling race condition
            return axios({
                 url: `${state.baseURL}communities/api/communities/GetPastAnnouncements`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    if (response && response.data) {
                        commit(storeMutation.setPastAnnouncementsForManageChapterStudio, response.data);
                    }
                    return response;
                })
                .catch((err) => {
                    throw err;
                });
        },
    ),
    [storeAction.getChapterStudioAnnouncementById]: wrapAction(
        storeAction.getChapterStudioAnnouncementById,
        ({ state }, announcementId) => {
            //handling race condition
            return axios({
                url: `${state.baseURL}communities/api/communities/getAnnouncementById/${announcementId}`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    if (response && response.data) {
                        return response.data;
                    }
                })
                .catch((err) => {
                    throw err;
                });
        },
    ),
    [storeAction.getChapterStudioPicklists]: wrapAction(
        storeAction.getChapterStudioPicklists,
        ({ state, commit }) => {
            //handling race condition
            return axios({
                 url: `${state.baseURL}communities/api/communities/GetAnnouncementPicklist`, // TODO - get this API
                // url: `/mocks/chapterStudioPicklists.json`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    if (response && response.data) {
                        commit(storeMutation.setChapterStudioPicklists, response.data);
                    }
                    return response;
                })
                .catch((err) => {
                    throw err;
                });
        },
    ),
    [storeAction.saveChapterStudioAnnouncement]: wrapAction(storeAction.saveChapterStudioAnnouncement, ({ state, commit }, requestBody) => {
        const requestData = requestBody;
        return axios({
            url: `${state.baseURL}communities/api/communities/saveChapterStudioAnnouncement`,
            headers: getHeadersWithFormData(),
            data: requestData,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setAnnouncementsForManageChapterStudio, response.data);
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data;
            });
    }),
};

const manageChapterStudioGetters = {
    [storeGetters.manageChapterStudioAllAnnouncements]: state => state.announcements,
    [storeGetters.manageChapterStudioPastAnnouncements] : state => state.pastAnnouncements,
    [storeGetters.manageChapterStudioBreadcrumbs]: state => state.breadcrumbList,
    [storeGetters.chapterStudioPicklists]: state => state.pickLists,
    [storeGetters.announcementFromState]: state => (announcementId) => {
        return state.announcements.find(ann => ann.id === announcementId) || null;
    },
};

export default {
    namespaced: true,
    state: {
        initialState: manageChapterStudioState,
        ...manageChapterStudioState,
    },
    mutations: { ...manageChapterStudioMutations },
    actions: { ...manageChapterStudioActions },
    getters: { ...manageChapterStudioGetters },
};
